import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import LoadingSpinner from "../components/LoadingSpinner";

// Permission presets for each role
const rolePermissions = {
  Sub_Admin: [
    'Dashboard',
    'eSim Store',
    'Transactions',
    'Wallet Top-up',
    'News and Updates',
    'Purchase History',
    'API Box',
    'Help and Support',
    'Create Ticket'
  ],
  Sub_Finance: [
    'Dashboard',
    'Transactions',
    'Wallet Top-up',
    'Purchase History',
   'News and Updates',
    'Create Ticket',
    'Top-up/Renewal Management',

  ],
  Sub_Support: [
    'Purchase History',
        'Transactions',
'Top-up/Renewal Management',
    'Help and Support',
    'Create Ticket',
        'News and Updates',

  ],
   Sub_Developer: [
    'API Box',
    'Help and Support',
    'Create Ticket'
  ],
  Sub_Reseller: [
   'Dashboard',
    'eSim Store',
    'Transactions',
    'News and Updates',
    'Purchase History',
'Top-up/Renewal Management',
    'Help and Support',
    'Create Ticket'
  ]
};

// Utility to map our formData to API format
          const partnerCode = localStorage.getItem("partnerCode");

function prepareApiPayload(formData, createdBy = partnerCode) {
  return {
    id: formData.id || 0,
    userName: formData.username,
    email: formData.email,
    phoneNumber: formData.phoneNumber,
    role: formData.role,
    permissions: formData.permissions.join(', '),
    password: formData.password,   // <-- add this line
    status: formData.status,
    country: formData.country,
    createdBy,
    updatedBy: createdBy
  };
}


// List of all available permission options
const permissionOptions = [
  'Dashboard',
  'eSim Store',
  'Transactions',
  'Wallet Top-up',
  'News and Updates',
  'Top-up/Renewal Management',
  'Purchase History',
  'API Box',
  'Help and Support',
  'Create Ticket'
];

const InventoryCustomer = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    phoneNumber: '',
    role: '',
    permissions: [],
    password: '',
    status: '',
    country: '',
    address: ''
  });

  const [error, setError] = useState('');
  const [serverData, setServerData] = useState([]);
  const [viewMode, setViewMode] = useState('customer');
  const [loading, setLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_BASE_URL;

  // Fetching all sub-users on "showData" mode
  useEffect(() => {
    if (viewMode === "showData") {
      fetchSubAccounts();
    }
  }, [viewMode]);

  const fetchSubAccounts = async () => {
          const partnerCode = localStorage.getItem("partnerCode");
    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}Renew/GetPartnerSubAccounts`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*',
        },
        body: JSON.stringify({
          id: 0,
                    partnerCode: partnerCode,
          pageSize: 100,
          pageIndex: 1,
        })
      });

      const data = await response.json();
      if (data.isSuccess) {
        setServerData(data.records);
      } else {
        toast.error('Failed to fetch records');
      }
    } catch (err) {
      toast.error('Server error fetching data');
    } finally {
      setLoading(false);
    }
  };

  const handleRoleChange = (e) => {
    const selectedRole = e.target.value;
    
    // Update the role first
    setFormData(prevFormData => ({
      ...prevFormData,
      role: selectedRole
    }));

    // If a role is selected and it exists in our presets, auto-select the permissions
    if (selectedRole && rolePermissions[selectedRole]) {
      setFormData(prevFormData => ({
        ...prevFormData,
        role: selectedRole,
        permissions: rolePermissions[selectedRole]
      }));
    } else if (selectedRole === '') {
      // If role is cleared, clear permissions too
      setFormData(prevFormData => ({
        ...prevFormData,
        role: selectedRole,
        permissions: []
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      setFormData({
        ...formData,
        permissions: checked
          ? [...formData.permissions, value]
          : formData.permissions.filter((permission) => permission !== value),
      });
    } else if (type === 'select-multiple') {
      const selectedPermissions = Array.from(e.target.selectedOptions, option => option.value);
      setFormData({ ...formData, permissions: selectedPermissions });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handlePermissionChange = (e) => {
    const { value, checked } = e.target;
    
    // If a role is selected, prevent manual permission changes
    if (formData.role && formData.role !== '') {
      toast.info(`Permissions are automatically set for ${formData.role} role. Change the role to customize permissions.`);
      return;
    }
    
    // Only allow permission changes when no role is selected
    setFormData({
      ...formData,
      permissions: checked
        ? [...formData.permissions, value]
        : formData.permissions.filter((permission) => permission !== value),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.username || !formData.email || !formData.phoneNumber || !formData.role || !formData.status) {
      setError('All required fields must be filled out');
      return;
    }

    // Prepare payload
              const partnerCode = localStorage.getItem("partnerCode");
    const payload = prepareApiPayload(formData, partnerCode);

    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}Renew/InsertUpdatePartnerSubAccount`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*',
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();
      if (data.isSuccess) {
        toast.success('User data saved to server successfully');
        setFormData({
          username: '',
          email: '',
          phoneNumber: '',
          role: '',
          password: '',
          permissions: [],
          status: '',
          country: '',
          address: ''
        });
        setViewMode('showData'); // Optionally auto-switch to data view
      } else {
        toast.error(data.message || 'Failed to save user');
      }
    } catch (error) {
      toast.error('Server error saving data');
    } finally {
      setLoading(false);
    }
  };

  // Check if a permission should be disabled (when a role is selected)
  const isPermissionDisabled = (permission) => {
    return formData.role && formData.role !== '';
  };

  // Check if a permission should be checked
  const isPermissionChecked = (permission) => {
    return formData.permissions.includes(permission);
  };

  return (
    <div className="bg-white p-2 shadow-2xl border-2">
      <h1 className="text-5xl font-bold mb-2">Sub-User Registration</h1>

      {error && <div className="text-red-500 mb-4">{error}</div>}
      
      {viewMode === "customer" && (
        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex flex-col">
                <label className="text-sm font-semibold text-gray-700 mb-2">User Name *</label>
                <input
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  className="w-full mt-2 p-2 border border-gray-300 rounded"
                  required
                />
              </div>
              <div className="flex flex-col">
                <label className="text-sm font-semibold text-gray-700 mb-2">Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full mt-2 p-2 border border-gray-300 rounded"
                  required
                />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="flex flex-col">
                <label className="text-sm font-semibold text-gray-700 mb-2">Phone Number *</label>
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  className="w-full mt-2 p-2 border border-gray-300 rounded"
                  required
                />
              </div>
              <div className="flex flex-col">
                <label className="text-sm font-semibold text-gray-700 mb-2">Password *</label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="w-full mt-2 p-2 border border-gray-300 rounded"
                  required
                />
              </div>
              <div className="flex flex-col">
                <label className="text-sm font-semibold text-gray-700 mb-2">Role *</label>
                <select
                  name="role"
                  value={formData.role}
                  onChange={handleRoleChange}
                  className="w-full mt-2 p-2 border border-gray-300 rounded"
                  required
                >
                  <option value="">Select Role</option>
                  {/* <option value="Sub_Admin">Admin</option> */}
                  {/* <option value="Sub_Finance">Finance</option> */}
                  <option value="Sub_Support">Support</option>
                  <option value="Sub_Reseller">User</option>
                  <option value="Sub_Finance">Finance</option>
                  <option value="Sub_Developer">Developer</option>
                </select>
              </div>
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-semibold text-gray-700 mb-2">
                Permissions *
                {formData.role && (
                  <span className="text-xs text-blue-600 ml-2">
                    (Auto-set for {formData.role} role)
                  </span>
                )}
              </label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                {permissionOptions.map((permission) => (
                  <label 
                    key={permission} 
                    className={`flex items-center space-x-2 ${
                      isPermissionDisabled(permission) ? 'opacity-70' : ''
                    }`}
                  >
                    <input
                      type="checkbox"
                      name="permissions"
                      value={permission}
                      checked={isPermissionChecked(permission)}
                      onChange={handlePermissionChange}
                      disabled={isPermissionDisabled(permission)}
                      className={isPermissionDisabled(permission) ? 'cursor-not-allowed' : ''}
                    />
                    <span className={isPermissionDisabled(permission) ? 'text-gray-500' : ''}>
                      {permission}
                    </span>
                  </label>
                ))}
              </div>
              {formData.role && (
                <p className="text-sm text-gray-600 mt-2">
                  Permissions are automatically configured based on the selected role. 
                  To customize permissions, please clear the role selection first.
                </p>
              )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex flex-col">
                <label className="text-sm font-semibold text-gray-700 mb-2">Status *</label>
                <select
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  className="w-full mt-2 p-2 border border-gray-300 rounded"
                  required
                >
                  <option value="">Select Status</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>

              <div className="flex flex-col">
                <label className="text-sm font-semibold text-gray-700 mb-2">Country/Region</label>
                <input
                  type="text"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  className="w-full mt-2 p-2 border border-gray-300 rounded"
                />
              </div>
            </div>
            <div className='flex gap-4'>
              <button
                type="submit"
                className="bg-teal-500 rounded-full p-4 text-white shadow-md hover:bg-[#1cbebe] transition duration-200"
                disabled={loading}
              >
                {loading ? 'Saving...' : 'Save User Data'}
              </button>
              <button
                type="button"
                onClick={() => setViewMode("showData")}
                className="bg-[#117575] rounded-full p-4 text-white shadow-md hover:bg-[#1cbebe] transition duration-200 "
                disabled={loading}
              >
                Show Saved Data
              </button>
            </div>
          </div>
        </form>
      )}

      {viewMode === "showData" && (
        <div className="overflow-x-auto">
          {loading ? (
            <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
                  <LoadingSpinner />
                </div>          ) : (
            <table className="w-full rounded-lg shadow-lg bg-white">
              <thead className="sticky top-0 bg-gray-200">
                <tr className="border-b">
                  <th className="text-center p-3">S.NO</th>
                  <th className="text-center p-3">Username</th>
                  <th className="text-center p-3">Email</th>
                  <th className="text-center p-3">Number</th>
                  <th className="text-center p-3">Role</th>
                  {/* <th className="text-center p-3">Permissions</th> */}
                  <th className="text-center p-3">Status</th>
                  <th className="text-center p-3">Country/Region</th>
                  <th className="text-center p-3">Password</th>
                </tr>
              </thead>
              {serverData.length === 0 ? (
    
        <p className="flex items-center justify-center text-lg bg-[#ffffff] font-bold text-center h-56 text-[#000000] ">
        No Active Sub user acccount
      </p>
) : (
  <tbody>
    {serverData.map((row, index) => (
      <tr key={row.id} className="border-b hover:bg-gray-100">
        <td className="text-center p-1">{index + 1}</td>
        <td className="text-center p-1">{row.userName}</td>
        <td className="text-center p-1">{row.email}</td>
        <td className="text-center p-1">{row.phoneNumber}</td>
        <td className="text-center p-1">{row.role}</td>
        <td className="text-center p-1">{row.status}</td>
        <td className="text-center p-1">{row.country}</td>
        <td className="text-center p-1">{row.password}</td>
      </tr>
    ))}
  </tbody>
)}

            </table>
          )}
          <button
            type="button"
            onClick={() => setViewMode("customer")}
            className="rounded-lg bg-[#117575] px-4 py-2 text-white font-bold shadow-lg hover:from-[#0e4040]"
          >
            Back to Form
          </button>
        </div>
      )}
    </div>
  );
};

export default InventoryCustomer;